import { useState, useEffect } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoIosSearch } from "react-icons/io";
import { debounceFunction } from "../utils";

const AsyncInputField = ({ 
    fetchSuggestions, 
    label, 
    name,
    previewKey = "name",
    type = "text", 
    placeholder = "Type to search...", 
    value,
    onChange, 
    onSelect, 
    error,
    setError,
    isRequired = true,
    disabled = false,
    icon = <IoIosSearch size={20} />
}) => {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    // Fetch suggestions with debouncing
    const fetchDebouncedSuggestions = debounceFunction(async (query = "") => {
        if (!String(query).trim() || String(query)?.length < 4) {
            setSuggestions([]);
            return;
        }
        setLoading(true);
        try {
            const results = await fetchSuggestions(query) || [];
            if(results.length == 0) setError("No data found!!!");
            setSuggestions(results);
        } catch (error) {
            setError(error.message || "");
            setSuggestions([]);
        } finally {
            setLoading(false);
        }
    }, 400);

    const handleSelect = (selectedValue) => {
        onChange({ target: { name, value: selectedValue[previewKey] ?? "" } }); // Simulate event
        setShowDropdown(false);
        if (onSelect) onSelect(selectedValue);
    }

    useEffect(() => {
        if(!disabled) fetchDebouncedSuggestions(value);
    }, [value]);

    return (
        <div className="input-container position-relative">
            {label && <label className="input-label">{label} {isRequired ? <span className="text-danger" style={{fontSize: "14px"}}><sup>*</sup></span> : null}</label>}
            <div className="input-wrapper">
                <input
                    disabled={disabled}
                    name={name}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck="false"
                    onChange={onChange}
                    onFocus={() => setShowDropdown(true)}
                    onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                    className={`input-box ${error ? "input-error" : ""}`} />
                {icon ? <span className="input-icon">
                    {loading ? <AiOutlineLoading3Quarters className="spin-element" size={20} /> : icon}
                </span> : null}
            </div>
            {error && <span className="error-message">{error}</span>}
            {showDropdown && suggestions.length > 0 && (
                <ul className="dropdown-menu show w-100" style={{ top: "75px" }}>
                    {suggestions.map((item, index) => (
                        <li key={index} className="dropdown-item" onMouseDown={() => handleSelect(item)}>{item[previewKey] ?? ""}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AsyncInputField;